import { Hourglass } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const InProgressIcon = DeckardIconWrapper({ Icon: Hourglass });
